import { Minus } from "@icons";
import classNames from "classnames";
import { ChangeEventHandler, useEffect, useRef } from "react";

interface SelectProps {
  id?: string;
  row?: boolean;
  checked: boolean;
  indeterminate?: boolean;
  label?: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
}

function Select({
  id = undefined,
  row = false,
  checked,
  indeterminate = false,
  label = undefined,
  onChange,
}: SelectProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const showMixed = indeterminate && !checked;

  useEffect(() => {
    if (inputRef.current) inputRef.current.indeterminate = indeterminate;
  }, [indeterminate, checked]);

  return (
    <label className="relative hit-target block w-5 h-5 hover:cursor-pointer">
      {!!label && <span className="sr-only">{label}</span>}
      <input
        ref={inputRef}
        id={id}
        type="checkbox"
        className="peer absolute opacity-0 h-0 w-0 cursor-pointer"
        onChange={onChange}
        checked={checked}
      />
      <span
        className={classNames(
          "absolute w-5 h-5 top-0 left-0 rounded",
          showMixed
            ? "grid place-items-center bg-primary text-on-primary"
            : "bg-page",
          "after:content-[''] after:hidden after:absolute",
          "after:left-[5px] after:top-[1px] after:w-2 after:h-3 after:border-primary after:rotate-45",
          "after:border-t-0 after:border-r-2 after:border-b-2 after:border-l-0",
          "peer-checked:bg-tint peer-checked:after:block",
          "peer-focus-visible:ring-2 peer-focus-visible:ring-focus",
          {
            "border border-primary peer-checked:border-transparent": row,
          },
        )}
      >
        {showMixed && <Minus size={14} strokeWidth={3} aria-hidden="true" />}
      </span>
    </label>
  );
}

export default Select;
